var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H3.14286V3.14286H2V2ZM3.14282 3.14323H4.28568V4.28609H3.14282V3.14323ZM3.14286 8.85677H2V9.99963H3.14286V8.85677ZM8.85718 8.85677H10V9.99963H8.85718V8.85677ZM5.42858 4.28516H4.28573V5.42801H5.42858V4.28516ZM5.42855 5.42839H6.57141V6.57124H5.42855V5.42839ZM7.71431 6.57161H6.57145V7.71447H7.71431V6.57161ZM7.71427 7.71484H8.85713V8.8577H7.71427V7.71484ZM7.71432 3.14323H8.85718V4.28609H7.71432V3.14323ZM10 2H8.85714V3.14286H10V2ZM6.57142 4.28516H7.71427V5.42801H6.57142V4.28516ZM5.42855 6.57161H4.28569V7.71447H5.42855V6.57161ZM3.14287 7.71484H4.28573V8.8577H3.14287V7.71484Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseS);
export default __webpack_public_path__ + "static/media/close-s.ccea75fa3902c27a837840034e83a150.svg";
export { ForwardRef as ReactComponent };